import Chart from 'chart.js/auto';

window.chartingInterop = {
    createChart:function(elementId, yData, xData){
        const ctx = document.getElementById(elementId);

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: xData,
                datasets: [{
                    label: 'Total Alerts Sent',
                    data: yData,
                    borderWidth: 1,
                    lineTension: 0.4
                }]
            },
            options: {
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    y: {
                        beginAtZero: true,
                        display: true,
                        title: {
                            display: true, 
                            text: '# of Alerts Sent', 
                            font: {
                                size: 14
                            }
                        }
                    },
                    x: {
                        grid: {
                            display: false,
                        },
                    } 
                },
                plugins: {
                    legend: {
                        position: 'bottom',  
                        labels: {
                            usePointStyle: true,  
                            pointStyle: 'line', 
                        }
                    }
                },
            }
        });
    }
}